<template>
  <g>
    <path
      d="M16 4.00018H8C7.45 4.00018 7 4.45018 7 5.00018V18.0002C7 18.5502 7.45 19.0002 8 19.0002H16C16.55 19.0002 17 18.5502 17 18.0002V5.00018C17 4.45018 16.55 4.00018 16 4.00018Z"
    />
    <path
      d="M4 6.00018C3.45 6.00018 3 6.45018 3 7.00018V16.0002C3 16.5502 3.45 17.0002 4 17.0002C4.55 17.0002 5 16.5502 5 16.0002V7.00018C5 6.45018 4.55 6.00018 4 6.00018Z"
    />
    <path
      d="M20 6.00018C19.45 6.00018 19 6.45018 19 7.00018V16.0002C19 16.5502 19.45 17.0002 20 17.0002C20.55 17.0002 21 16.5502 21 16.0002V7.00018C21 6.45018 20.55 6.00018 20 6.00018Z"
    />
  </g>
</template>
